import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { createLocation, updateLocation } from '../api/apiLocation';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateLocation extends Component {

    emptyLocation = {
        isActive: true,
        address: null,
        postalCode: '',
        country: null,
        city: null,
        floor: '',
        room: null
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialLocation: JSON.parse(JSON.stringify(this.emptyLocation)),
            location: JSON.parse(JSON.stringify(this.emptyLocation)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyLocation))
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.locationToEdit != null) {
            if (prevState.location.id !== this.props.locationToEdit.id) {
                this.setState({ location: this.props.locationToEdit, initialLocation: JSON.parse(JSON.stringify(this.props.locationToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            location: JSON.parse(JSON.stringify(this.emptyLocation))
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let { location } = this.state;

        location[name] = value;
        this.setState({ location: location })
    };

    createOrUpdateLocation = (e) => {

        e.preventDefault();
        let { location } = this.state
        if (!this.validateForm()) {
            return;
        }

        const requestBodyCreate = {
            ...this.state.location,
            clientId: this.props.selectedClient.id
        }

        let action = this.props.locationToEdit ? updateLocation : createLocation;
        action(this.props.locationToEdit ? location : requestBodyCreate).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.locationToEdit ? 'update_message_location' : 'create_message_location'), { variant: 'success' });
            this.closeDialog()
            !this.props.assetFlag && this.props.getLocations()
            this.props.assetFlag && this.props.getLocationsSimple(response.data.data.id)
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("location_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(
                    this.props.t(this.props.locationToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('location') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { location } = this.state;
        let valid = true;
        if (!location.address
            || !location.postalCode
            || !location.city
            || !location.country
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { location, initialLocation } = this.state

        return (
            <Dialog onClose={this.closeDialog} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.locationToEdit ? this.props.t("edit_location") : this.props.t("new_location")}</DialogTitle>
                <form onSubmit={this.createOrUpdateLocation} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"address"}
                                            name="address"
                                            onChange={this.handleChange}
                                            value={location.address || ''}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"city"}
                                            name="city"
                                            onChange={this.handleChange}
                                            value={location.city || ''}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"country"}
                                            name="country"
                                            onChange={this.handleChange}
                                            value={location.country || ''}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"postal_code"}
                                            name="postalCode"
                                            onChange={this.handleChange}
                                            value={location.postalCode}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"floor"}
                                                name="floor"
                                                onChange={this.handleChange}
                                                value={location.floor}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"room"}
                                                name="room"
                                                onChange={this.handleChange}
                                                value={location.room || ''}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedFromControlLabel
                                                onChange={this.handleChange}
                                                name="isActive"
                                                checked={location.isActive}
                                                label={"active"}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained" >
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.locationToEdit ? (JSON.stringify(location) === JSON.stringify(initialLocation)) : !this.validateForm()}>
                            {this.props.locationToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog >
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateLocation)))
